import React, { useState } from "react";

import {
  Box,
  Grid,
  Modal,
  TextField,
  ToggleButtonGroup,
  ToggleButton,
  Button,
} from "@mui/material";
import s from "./ModalConcentrators.module.css";

import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

const ModalConcentrators = ({
  filters,
  setFilters,
  open,
  setOpen,
  setSearching,
}) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid
            item
            container
            xs={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Grid item xs={10} className={s.exit}>
              <div className={s.titleModal}>
                <p>{t("filter")}</p>
                <span>{t("filterConfig")}</span>
              </div>
              <CloseIcon
                onClick={() => setOpen(false)}
                className={s.exitIcon}
                sx={{ color: "primary.dark" }}
              />
            </Grid>

            <Grid item container xs={10} className={s.filters}>
              <Grid item xs={12} className={s.item}>
                <p>{`${t("number")} / DNI / CUIT`}</p>
                <TextField
                  placeholder={`${t("number")} / DNI / CUIT`}
                  value={filters.number}
                  sx={{ width: "100%" }}
                  type={"number"}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...filters,
                      number: e.target.value,
                    }))
                  }
                />
              </Grid>

              <Grid item xs={12} className={s.item}>
                <p>{t("name")}</p>
                <TextField
                  value={filters.name}
                  placeholder={t("nameOfASalePoint")}
                  sx={{ width: "100%" }}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...filters,
                      name: e.target.value,
                    }))
                  }
                />
              </Grid>

              <Grid item xs={12} className={s.item}>
                <p>{t("state")}</p>
                <ToggleButtonGroup
                  color="primary"
                  exclusive
                  value={filters.status}
                  aria-label="Platform"
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...filters,
                      status: e.target.value,
                    }))
                  }
                >
                  <ToggleButton value="any">{t("all")}</ToggleButton>
                  <ToggleButton value="ENABLED">{t("enabled")}</ToggleButton>
                  <ToggleButton value="DISABLED">{t("disabled")}</ToggleButton>
                </ToggleButtonGroup>
              </Grid>
            </Grid>

            <Grid item xs={12} className={s.button}>
              <Button
                onClick={() => {
                  setSearching(true);
                  setOpen(false);
                }}
                variant="contained"
                disabled={
                  filters.name === "" &&
                  filters.number === 0 &&
                  filters.status === "any"
                }
              >
                {t("find")}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ModalConcentrators;
